import { useCallback } from 'react';
import { useEnrichErrorToast } from '@hooks/use-enrich-error-toast';
import type { ToastProps } from '@models/types';
import { useAppDispatch, useAppSelector } from '@store';
import { toastSlice } from '@store/slices/toast-slice';
import { v4 as uuidv4 } from 'uuid';

export const useToast = () => {
    const toasts = useAppSelector((state) => state.toast.items);
    const dispatch = useAppDispatch();
    const { enrichToast } = useEnrichErrorToast();

    const showToast = useCallback(
        (data: Omit<ToastProps, 'id'>) => {
            const id = uuidv4();
            const enrichedData = enrichToast(data);

            dispatch(
                toastSlice.actions.addToast({
                    id,
                    ...enrichedData,
                }),
            );
        },
        [dispatch, enrichToast],
    );

    const hideToast = useCallback(
        (id: string) => {
            dispatch(toastSlice.actions.hideToast(id));
        },
        [dispatch],
    );

    return { showToast, hideToast, toasts };
};
